/* eslint-disable no-multi-spaces */
// Menu types IDs

import { ReactElement } from "react-markdown/lib/react-markdown"

// -------------------------------
export const BIKE_MANAGEMENT_ID = 1 // Gestion de vélo
export const FLEET_MANAGEMENT_ID = 2 // Gestion de flotte
export const BICYTRUST_CONTRACT_ID = 3 // Contrat Bicytrust
export const TEAM_MANAGEMENT_ID = 4 // Gestion d'équipe
export const CONTACT_SUPPORT_ID = 5 // Contact support
export const LABEL_ORDER_ID = 6 // Commande d'étiquettes
export const MENU_BO = 7 // Menu BO

// -------------------------------

export type ItemMenuType = {
	id?: number
	label: string
	url?: string
	icon?: ReactElement
	isVisible?: boolean
	external?: boolean
	children?: ItemMenuType[]
	dataCy: string
}
